/* eslint-disable react-hooks/exhaustive-deps */
import { useContext } from 'react';
import { InboundContext } from '../../../context/InboundContext';
import Logo from '../Logo/Logo';
import styles from './TopHeader.module.css';

export default function TopHeader() {
  const { inboundData } = useContext(InboundContext);

  return (
    <div className={styles.headerContainer}>
      <Logo logoUrl={inboundData?.landingPage?.images?.logo} isExpanded />
    </div>
  );
}
